import type { PortableTextBlock } from '@portabletext/react';
import type { SanityDocument } from '@sanity/client';
import SimpleRichText from '../richTextComponents/SimpleRichText';
import { simpleRichTextGroq } from '../richTextComponents/simpleRichTextGroq';
import Grape from './Grape';
import * as style from './Grape.module.css';

export const grapeItemGroq = /* groq */ `{
    _id,
    _type,
    "slug": slug.current,
    name,
    summary,
    description[] ${simpleRichTextGroq},
    'synonyms': *[_type == ^._type && mainEntry._ref == ^._id].name,
    grapeType,
    mainEntry -> {
        'slug': slug.current,
        name
    },
    'listPage': *[_type == 'listPage' && listType == ^._type][0] { _id, title },
}`;

export interface GrapeItemProps extends SanityDocument {
    _type: 'grape';
    slug: string;
    name: string;
    summary: string;
    description: PortableTextBlock[];
    synonyms: string[];
    grapeType: 'green' | 'blue';
    mainEntry?: { name: string; slug: string };
    listPage: { _id: string; title: string; path: string };
}

export default function GrapeItem({ name, summary, description, synonyms, grapeType, slug, mainEntry, listPage }: GrapeItemProps) {
    return (
        <div className={style.grape} id={name[0]?.toLowerCase()}>
            <details id={slug} data-toggle-context="drue">
                <summary>
                    <Grape name={name} summary={summary} grapeType={grapeType} slug={slug} listPage={listPage} synonyms={synonyms} />
                    {mainEntry && (
                        <p>
                            <span>Se: </span>
                            <a href={`${listPage?.path}?id=${mainEntry.slug}`}>{mainEntry.name}</a>
                        </p>
                    )}
                </summary>
                <div className={style.grapeInfo}>
                    <SimpleRichText value={description} />
                </div>
            </details>
        </div>
    );
}

export function GrapeItemPage({ name, summary, description, synonyms, grapeType, slug, mainEntry, listPage }: GrapeItemProps) {
    return (
        <div className={style.grape} id={name[0]?.toLowerCase()}>
            <div className={style.details}>
                <div className={style.summary}>
                    <Grape name={name} summary={summary} grapeType={grapeType} slug={slug} listPage={listPage} synonyms={synonyms} title="h1" />
                    {mainEntry && (
                        <p>
                            <span>Se: </span>
                            <a href={`${listPage?.path}?id=${mainEntry.slug}`}>{mainEntry.name}</a>
                        </p>
                    )}
                </div>
                <div className={style.grapeInfo}>
                    <SimpleRichText value={description} />
                </div>
            </div>
        </div>
    );
}
